import { useEffect, useRef } from 'react';
import { useDispatch } from 'react-redux';
import { useStableKey } from './useStableKey';

/**
 * Dispatches a paginated list fetch when query inputs change.
 * Uses a stable serialized key so object identity churn does not retrigger fetches.
 * Skips back-to-back duplicate dispatches for the same query key.
 */
export function usePaginatedListFetch({ enabled = true, action, payload }) {
  const dispatch = useDispatch();
  const payloadKey = useStableKey(payload);
  const payloadRef = useRef(payload);
  const lastDispatchedKeyRef = useRef(null);
  payloadRef.current = payload;

  useEffect(() => {
    if (!enabled || typeof action !== 'function') return;
    if (payloadKey === lastDispatchedKeyRef.current) return;

    lastDispatchedKeyRef.current = payloadKey;
    dispatch(action(payloadRef.current));
  }, [enabled, action, payloadKey, dispatch]);
}
